import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { ButtonTriggerEvent } from '../../common/components';
import { ConfirmModalComponent } from '../../common/components/confirm.modal/confirm.modal.component';
import { ConfirmModalActions, ConfirmModalData } from '../../common/components/confirm.modal/confirm.modal.provider';
import { getRouteUrl, routeConfigs } from '../../common/constants/route.config';
import { clone } from '../../common/extensions';
import { AuthService } from '../../common/services/auth.service';
import { ModalService } from '../../common/services/modal.service';
import { Account } from '../../models/admin/account';
import { HubEvent } from '../../models/hub/hub.event';
import { AccountApiService } from '../../services/account.api.service';
import { AdminSocketService } from '../../services/admin.socket.service';
import { EventTimeService } from '../../services/event.time.service';
import { SchedulerApiService } from '../../services/scheduler.api.service';
import { ShowInfoModalComponent } from '../hub/show.info.modal/show.info.modal.component';
import { InfoModalData, ShowInfoModalActions } from '../hub/show.info.modal/show.info.modal.provider';
import { AddSpiderEvenetsModalComponent } from './add.spider.events.modal/add.spider.events.modal.component';
import {
  AddSpiderEventsModalActions,
  AddSpiderEventsModalData,
} from './add.spider.events.modal/add.spider.events.modal.provider';
import { localStorageKeys } from '../../common/constants/local.storage.keys';
import * as jwt_decode from 'jwt-decode';
import { TokenInfo } from '../../models/auth/token.info';
import { SerpConfig } from '../../models/admin/serp.config';
import { SpiderPage } from './accounts/event.spider/event.spider.modal.component';
import { AlertifyService } from '../../services/alertify.service';
import { TravelBuddyConversationsModalComponent } from './accounts/travel.buddy.conversations/travel.buddy.conversations.modal.component';
import {
  TravelBuddyConversationsModalActions,
  TravelBuddyConversationsModalData,
} from './accounts/travel.buddy.conversations/travel.buddy.conversations.modal.provider';
import { EventPullingStatusModalComponent } from './accounts/event.pulling.status/event.pulling.status.modal.component';

@Component({
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AdminComponent implements OnInit {
  public isSchedulerRunning: boolean;
  public loading: boolean;
  public schedulerProgressReports: [
    {
      message: string;
      color: string;
    }
  ] = [] as any;
  @ViewChild('reportsContainer') public reportsContainer: ElementRef;
  public accountName: string;
  public isEventPuller = false;
  public accountId: string;
  public eventSource: string;
  public accounts: Account[];
  public codeFormGroup: FormGroup;
  public code = null;
  public identifier = null;
  public token = null;
  public isShowUpdatePlaceBtn = false;
  public isShowUpdateMultiDateEvents = false;
  public isShowMissingAddress = false;
  public isShowUpdateEventfulImage = false;
  public isShowRemoveOutdatedEventsBtn = false;
  public isShowRemoveDuplicatedPlaces = false;
  public isShowCode = false;
  public isShowEventbritePlaceId = false;
  public isShowUpdateAllowedCover = false;
  public isShowFromTo = false;
  public from = null;
  public to = null;
  public isSpiderUseProxy = true;
  public isUseCityCodeAPIOnEventbriteHomepage = true;
  public isUseCityCode = true;
  public isUseLinks = true;
  public isAutoScrolling = true;
  public isShowCacheLog = true;
  public spiderTip = 'e.g., https://www.facebook.com/pg/msmuseumart/events/';
  public isShowUseLinkChk = false;
  public fbPages: any[] = [];
  public spiderLink = ''; //'https://www.facebook.com/pg/rockandrollhalloffame/events/, https://www.facebook.com/pg/msmuseumart/events/';
  public serpGoogleConfig = new SerpConfig(false, 30, 50, false);
  @ViewChild('outlet') private _outlet: RouterOutlet;

  constructor(
    private router: Router,
    private authService: AuthService,
    private accountApiService: AccountApiService,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private schedulerApiService: SchedulerApiService,
    private adminSocketService: AdminSocketService,
    private alertify: AlertifyService
  ) {
    this.adminSocketService.init();
  }

  public ngOnInit() {
    const authToken = localStorage.getItem(localStorageKeys.authToken);
    let tokenInfo = jwt_decode<TokenInfo>(authToken);
    if (tokenInfo && tokenInfo.role === 'ig-event-puller') {
      this.isEventPuller = true;
    }
    console.log('tokenInfo', tokenInfo);

    this.fetchAccounts();
    this.eventSource = 'all';
    this.adminSocketService.socket.on(
      'scheduler-status',
      (isRunning) => (this.isSchedulerRunning = isRunning)
    );
    this.adminSocketService.socket.on('scheduler-progress', (report) => {
      if (this.isShowCacheLog) {
        this.schedulerProgressReports.push(report);
      } else {
        if (
          !report.message.includes('Cache hit') &&
          !report.message.includes('Cache set') &&
          !report.message.includes('Checking ig-version')
        ) {
          this.schedulerProgressReports.push(report);
        }
      }
      if (this.isAutoScrolling) {
        setTimeout(() => {
          this.reportsContainer.nativeElement.scrollTo({
            top: this.reportsContainer.nativeElement.scrollHeight,
          });
        });
      }
    });
    this.codeFormGroup = this.formBuilder.group({
      evalCode: [null],
      code: [null],
      identifier: [null],
      token: [null],
      from: [null],
      to: [null],
      spider: [null],
      gatherNumber: [null],
      maxPages: [null],
    });

    let wholeSpinner = document.getElementById('skeleton-mask');
    if (wholeSpinner) {
      wholeSpinner.style.display = 'none';
    }
  }

  public synceData() {
    this.confirm(() => {
      this.schedulerProgressReports = [] as any;
      if (this.accountName) {
        this.schedulerApiService
          .synceOne(this.accountName, this.eventSource, this.from, this.to)
          .subscribe();
      } else {
        this.schedulerApiService.synceAll(this.eventSource).subscribe();
      }
    });
  }

  public updatePlaces() {
    this.confirm(() => {
      this.schedulerApiService.updatePlaces(this.accountName, this.from, this.to).subscribe();
    });
  }

  public runEventbriteConjob() {
    this.confirm(() => {
      this.schedulerApiService
        .runEventbriteConjob(this.isUseCityCode, this.isUseCityCodeAPIOnEventbriteHomepage)
        .subscribe();
    });
  }

  public tagPlaceImageAvailability() {
    this.confirm(() => {
      this.schedulerApiService
        .tagPlaceImageAvailability(this.accountName, this.from, this.to)
        .subscribe();
    });
  }

  public travelBuddyConversations() {
    this.modalService.show({
      component: TravelBuddyConversationsModalComponent,
      providers: [
        { provide: TravelBuddyConversationsModalActions, useValue: null },
        {
          provide: TravelBuddyConversationsModalData,
          useValue: new TravelBuddyConversationsModalData(),
        },
      ],
      panelClass: 'width-modal-4',
    });
  }

  public eventPullingStatus() {
    this.modalService.show({
      component: EventPullingStatusModalComponent,
      panelClass: 'width-modal-2',
    });

    // this.schedulerApiService.eventPullingStatus().subscribe((data) => {
    //   this.modalService.show({
    //     component: ShowInfoModalComponent,
    //     providers: [
    //       {provide: ShowInfoModalActions, useValue: null},
    //       {
    //         provide: InfoModalData,
    //         useValue: new InfoModalData(
    //           'Eventbrite pulling status',
    //           null,
    //           data.map((x) => {
    //             return `${x.hubName} - ${new Date(x.eventbrite.lastRunTime).toLocaleString()}`;
    //           })
    //         ),
    //       },
    //     ],
    //     panelClass: 'width-modal-2',
    //   });
    // });
  }

  public updatePlaceByFBId() {
    if (this.identifier) {
      this.confirm(() => {
        this.schedulerApiService
          .updatePlaceByFBId(this.identifier, this.accountName, this.token)
          .subscribe();
      });
    }
  }

  public deleteOutDatedEvents() {
    this.confirm(() => {
      this.schedulerApiService.deleteOutDatedEvents().subscribe();
    });
  }

  public updateMultiDateEvents() {
    this.confirm(() => {
      this.schedulerApiService.updateMultiDateEvents().subscribe();
    });
  }

  public getLatAndLngFromGoogleForMissingAddressEvents() {
    this.confirm(() => {
      this.schedulerApiService
        .getLatAndLngFromGoogleForMissingAddressEvents(this.accountName)
        .subscribe();
    });
  }

  public updatEventImages() {
    this.confirm(() => {
      this.schedulerApiService.updatEventImages(this.accountName).subscribe();
    });
  }

  public removeDuplicatedPlaces() {
    this.confirm(() => {
      this.schedulerApiService.removeDuplicatedPlaces().subscribe();
    });
  }

  public updatePlacesForNext() {
    this.confirm(() => {
      this.schedulerApiService.updatePlacesForNext().subscribe();
    });
  }

  public loadSpiderPages() {
    if (!this.accountId || this.eventSource === 'all') {
      return;
    }
    this.loading = true;
    this.fbPages = [];
    this.spiderLink = '';
    this.accountApiService.getSpiderEventPages(this.accountId).subscribe((pages) => {
      // const socialName = this.eventSource === 'eventbrite' ? 'eventbrite' : 'facebook';
      this.fbPages = pages
        ? clone(pages)
            .pages.filter((x) => x.socialName.indexOf(this.eventSource) >= 0)
            .map((x) => {
              return {
                url: x.url,
                tag: x.tag,
                checked: false,
                socialName: x.socialName,
              };
            })
        : [];
      this.isUseLinks = !this.fbPages.length;
      this.isShowUseLinkChk = !!this.fbPages.length;
      this.loading = false;
    });
  }

  public filterUnofficialPlaces() {
    this.schedulerApiService.filterUnofficialPlaces(this.accountName).subscribe();
  }

  public getFBPulledEvents($event) {
    if (this.eventSource.indexOf('serp|google') >= 0) {
      this.schedulerApiService
        .getSpiderPulledEvents(this.eventSource)
        .finally($event.complete)
        .subscribe((events) => {
          const checkedSerpCities = this.fbPages.filter((x) => x.checked);
          this.showSerpGoogleEvents(events, checkedSerpCities);
        });
      return;
    }

    let socialName = this.eventSource === 'eventbrite' ? 'eventbrite' : 'facebook';
    this.schedulerApiService
      .getSpiderPulledEvents(socialName)
      .finally($event.complete)
      .subscribe((events) => {
        if (!events) {
          console.log(`no events: ${events}`);
          return;
        }
        events.forEach((page) => {
          page.events.forEach((x) => EventTimeService.processEventTime(x));
        });
        this.modalService.show({
          component: AddSpiderEvenetsModalComponent,
          providers: [
            { provide: AddSpiderEventsModalActions, useValue: null },
            {
              provide: AddSpiderEventsModalData,
              useValue: new AddSpiderEventsModalData(
                this.accountName,
                this.accounts,
                events,
                socialName
              ),
            },
          ],
          panelClass: 'width-modal-90p',
        });
      });
  }

  public stopPullingEvents($event) {
    this.schedulerApiService
      .stopPullingEvents()
      .finally($event.complete)
      .subscribe((events) => {});
  }

  public async spider($event) {
    if (this.eventSource.indexOf('serp|google') >= 0) {
      this.pullSerpGoogleEvents($event);
      return;
    }
    if (this.eventSource === 'eventbrite') {
      let pages = this.fbPages.filter((y) => y.checked);
      if (pages.length > 1) {
        this.alertify.warning(`Only the first page will be executed for now`);
      }

      let result = await this.pullEventbriteEventsByAPI(pages[0]);
      if (result && result.success) {
        let events = result.events;

        if (!events || !events.length) {
          this.alertify.warning(`No events found, please check the city code`);
          return;
        }

        events.forEach((x) => EventTimeService.processEventTime(x, false));
        const page = [{ events, pageLink: pages[0]['url'] }];
        this.modalService.show({
          component: AddSpiderEvenetsModalComponent,
          providers: [
            { provide: AddSpiderEventsModalActions, useValue: null },
            {
              provide: AddSpiderEventsModalData,
              useValue: new AddSpiderEventsModalData(
                this.accountName,
                this.accounts,
                page,
                this.eventSource
              ),
            },
          ],
          panelClass: 'width-modal-90p',
        });
      } else {
        alert(`No events pulled from this link`);
      }
      return;
    }

    let socialName = this.eventSource !== 'eventbrite' ? 'facebook' : 'eventbrite';
    if (!this.isUseLinks) {
      this.spiderLink = '';
      let pages = this.fbPages.filter((y) => y.checked);
      pages.forEach((x, i) => {
        this.spiderLink += x.url + (i === pages.length - 1 ? '' : ',');
      });
    }
    console.log(this.spiderLink);

    this.schedulerApiService
      .spiderLink(this.spiderLink, socialName, this.isSpiderUseProxy, this.accountName)
      .finally(() => {
        $event.complete();
      })
      .subscribe((events) => {
        if (!events) {
          console.log(`no events: ${events}`);
          return;
        }
        events.forEach((page) => {
          page.events.forEach((x) => EventTimeService.processEventTime(x));
        });
        this.modalService.show({
          component: AddSpiderEvenetsModalComponent,
          providers: [
            { provide: AddSpiderEventsModalActions, useValue: null },
            {
              provide: AddSpiderEventsModalData,
              useValue: new AddSpiderEventsModalData(
                this.accountName,
                this.accounts,
                events,
                socialName
              ),
            },
          ],
          panelClass: 'width-modal-90p',
        });
      });
  }

  public addEventbritePlaceId($event: ButtonTriggerEvent) {
    console.log(`page: ${this.from}, placeId: ${this.to}`);
    this.schedulerApiService
      .setSpiderPageConfig(this.from, this.to, 'eventbrite')
      .finally($event.complete)
      .subscribe();
  }

  public updatePlaceCover($event: ButtonTriggerEvent) {
    this.schedulerApiService.updatePlaceCover().finally($event.complete).subscribe();
  }

  public logout() {
    this.authService.logout();
    this.router.navigateByUrl(getRouteUrl(routeConfigs.auth.login));
  }

  public setAccount(account: Account) {
    this.accountName = account ? account.userName : null;
    this.accountId = account ? account._id : null;
    this.loadSpiderPages();
  }

  public setSource(source) {
    this.eventSource = source;
    if (source === 'eventbrite') {
      this.spiderTip = 'e.g., https://www.eventbrite.com/d/ga--brunswick/all-events/';
      this.spiderLink = '';
    } else if (source === 'facebook') {
      this.spiderTip = 'e.g., https://www.facebook.com/pg/msmuseumart/events/';
      this.spiderLink = '';
    } else if (source.indexOf('serp|google') >= 0) {
      this.spiderLink = 'serp google events'; //'https://serpapi.com/search.json?engine=google_events&q=Events+in+Savannah&hl=en&gl=us&&api_key=b25cfa1b3644220f01a3e6d0e611adc0d6825ef67eb53c91d181e72bb71b27f5';
    }
    this.loadSpiderPages();
  }

  public checkCode() {
    this.isShowUpdatePlaceBtn = this.code.indexOf('place') !== -1;
    this.isShowUpdateMultiDateEvents = this.code.indexOf('multi') !== -1;
    this.isShowRemoveOutdatedEventsBtn = this.code.indexOf('outdated') !== -1;
    this.isShowMissingAddress = this.code.indexOf('missing') !== -1;
    this.isShowUpdateEventfulImage = this.code.indexOf('eventful') !== -1;
    this.isShowRemoveDuplicatedPlaces = this.code.indexOf('duplicate') !== -1;
    this.isShowFromTo = this.code.indexOf('from') !== -1;
    this.isShowEventbritePlaceId = this.code.indexOf('eb') !== -1;
    this.isShowUpdateAllowedCover = this.code.indexOf('allow') !== -1;
  }

  public clearReport() {
    this.schedulerProgressReports = [] as any;
  }

  public confirm(run) {
    let actions = <ConfirmModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
        event.complete();
        run();
      },
    };
    let data = <ConfirmModalData>{
      confirmModalIcon: 'warning',
      confirmModalTitle: 'Alert',
      confirmModalDescription: 'Are you sure you want to do this?',
      confirmModalConfirmButtonText: 'Yes',
      confirmModalCancelButtonText: 'Cancel',
      isAsync: true,
    };

    this.modalService.show({
      component: ConfirmModalComponent,
      providers: [
        { provide: ConfirmModalActions, useValue: actions },
        { provide: ConfirmModalData, useValue: data },
      ],
    });
  }

  private fetchAccounts() {
    this.accountApiService.getAccounts().subscribe((accounts) => {
      accounts = accounts.filter((x) => x.userName !== 'admin');
      this.accounts = accounts;
    });
  }

  private async pullEventbriteEventsByAPI(page: SpiderPage) {
    // if (!page || !page.tag) {
    //   alert(
    //     "The selected link doesn't have a city code attached, please use dev server to run the crawler for this link."
    //   );
    //   return;
    // }

    this.isSchedulerRunning = true;
    return await this.schedulerApiService
      .eventbriteApi(this.accountName, page)
      .finally(() => (this.isSchedulerRunning = false))
      .toPromise();
  }

  private async pullSerpGoogleEvents($event: ButtonTriggerEvent) {
    this.isSchedulerRunning = true;

    if (!this.accountName) {
      console.log('Pull Serp Google for all accounts');
      await this.schedulerApiService.serpApi(null, null, this.serpGoogleConfig).toPromise();
      $event.complete();
      return;
    }

    const checkedSerpCities = this.fbPages.filter((x) => x.checked);
    console.log(checkedSerpCities);

    if (!checkedSerpCities || !checkedSerpCities.length) {
      this.isSchedulerRunning = false;
      alert(
        'No city selected, if there is no city, please set city name for this account in spider pages settings'
      );
      return;
    }

    const eventsPulled: any[] = [];
    for (const serpGoogle of checkedSerpCities) {
      if (serpGoogle && serpGoogle.url) {
        let city = serpGoogle.url;
        if (serpGoogle.socialName.includes('serp|google|keywords')) {
          this.serpGoogleConfig.type = 'keywords';
          this.serpGoogleConfig.keywords = serpGoogle.url;
          city = serpGoogle.tag;
        } else {
          this.serpGoogleConfig.type = 'city';
          this.serpGoogleConfig.keywords = undefined;
        }
        const result = await this.schedulerApiService
          .serpApi(this.accountName, city, this.serpGoogleConfig)
          .finally($event.complete)
          .toPromise();
        console.log(result);
        result.success && eventsPulled.push(...result.events);
        !result.success && console.log(`Error when pulling ${serpGoogle.url}`, result.msg);
      }
    }

    /**
     *    sometimes the pulling takes too long, timeout will force the async request to stop and execute the following code.
     *    So here we add the check status function, if the pulling is completed, show the saving popup, otherwise wait and check again
     * */
    const status = await this.schedulerApiService.checkSerpStatus().toPromise();
    console.log(status);

    if (!status.isPulling) {
      this.isSchedulerRunning = false;

      this.showSerpGoogleEvents(eventsPulled, checkedSerpCities);
    } else {
      let maxTrying = 30,
        retry = 0;
      const checkInterval = setInterval(async () => {
        const status = await this.schedulerApiService.checkSerpStatus().toPromise();
        if (!status.isPulling) {
          clearInterval(checkInterval);

          this.isSchedulerRunning = false;
          this.schedulerApiService
            .getSpiderPulledEvents('serp|google')
            .finally($event.complete)
            .subscribe((events) => {
              this.showSerpGoogleEvents(events, checkedSerpCities);
            });
        } else {
          retry++;
          if (retry >= maxTrying) {
            clearInterval(checkInterval);
            this.isSchedulerRunning = false;
            alert(
              'Seems the pulling is still in progress, please try to use the "SAVING EVENTS POPUP" to get pulled events, or retry the pulling'
            );
          }
        }
      }, 10 * 1000);
    }
  }

  private showSerpGoogleEvents(eventsPulled: any[], checkedSerpCities: any[]) {
    if (!eventsPulled.length) {
      alert(`No events found`);
      return;
    }
    eventsPulled.forEach((x) => EventTimeService.processEventTime(x, false));
    const page = [
      { events: eventsPulled, pageLink: checkedSerpCities.map((x) => x.url).join('; ') },
    ];
    this.modalService.show({
      component: AddSpiderEvenetsModalComponent,
      providers: [
        { provide: AddSpiderEventsModalActions, useValue: null },
        {
          provide: AddSpiderEventsModalData,
          useValue: new AddSpiderEventsModalData(
            this.accountName,
            this.accounts,
            page,
            this.eventSource
          ),
        },
      ],
      panelClass: 'width-modal-90p',
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/admin.component.ts